import { ReactNode } from "react";
import styles from "./MobileBanner.module.css";

type Props = {
  children: ReactNode;
  scrollItemCount?: number;
};

export default function Marquee({ children, scrollItemCount = 3 }: Props) {
  const marqueeItems = Array.from({ length: scrollItemCount }, (_, i) => (
    <div key={i} className={styles.marqueeItem}>
      {children}
    </div>
  ));

  return (
    <div className={styles.marquee}>
      <div className={styles.marqueeTrack}>{marqueeItems}</div>
      <div aria-hidden="true" className={styles.marqueeTrack}>
        {marqueeItems}
      </div>
    </div>
  );
}
